export default "__VITE_ASSET__BLZvgW9K__"